import parse, { type HTMLReactParserOptions } from "html-react-parser";
import DOMPurify from "dompurify";
import type { Config as DomPurifyConfig } from "dompurify";

const HTML_FRAGMENT_SANITIZE_OPTIONS: DomPurifyConfig = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ["target", "rel"],
  ADD_TAGS: ["style"],
};

const HTML_DOCUMENT_SANITIZE_OPTIONS: DomPurifyConfig = {
  ...HTML_FRAGMENT_SANITIZE_OPTIONS,
  WHOLE_DOCUMENT: true,
};

export function sanitizeHtml(html: string | null | undefined): string {
  const text = typeof html === "string" ? html : "";
  if (!text.trim()) return "";
  return DOMPurify.sanitize(text, HTML_FRAGMENT_SANITIZE_OPTIONS) as string;
}

export function sanitizeHtmlDocument(html: string | null | undefined): string {
  const text = typeof html === "string" ? html : "";
  if (!text.trim()) return "";
  return DOMPurify.sanitize(text, HTML_DOCUMENT_SANITIZE_OPTIONS) as string;
}

export function parseSanitizedHtml(
  html: string | null | undefined,
  options?: HTMLReactParserOptions,
) {
  const sanitized = sanitizeHtml(html);
  if (!sanitized.trim()) return null;
  return parse(sanitized, options);
}
